/**
 * Returns true when the current device behaves like a desktop: it can hover and
 * has a fine pointer (mouse / trackpad).
 */
export const isDesktopDevice = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(hover: hover) and (pointer: fine)').matches;
